<cw-markdown [markdownText]="message" [applyCustomStyle]="false"> </cw-markdown>
